import { render, staticRenderFns } from "./BlockImageLeftAccordionRightGrayBackground.vue?vue&type=template&id=df8ba4a0&"
import script from "./BlockImageLeftAccordionRightGrayBackground.vue?vue&type=script&lang=js&"
export * from "./BlockImageLeftAccordionRightGrayBackground.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports